import { Box, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { CSSProperties, FC, ReactNode } from 'react';

type WbDrawerActionsProps = {
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
};

const useStyles = makeStyles(
  theme => ({
    root: {
      display: 'flex',
      padding: theme.spacing(1),
      borderTop: `1px solid ${theme.palette.grey[300]}`,
      gap: theme.spacing(1),
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
    },
  }),
  { name: 'WbDrawerActions' },
);

export const WbDrawerActions: FC<WbDrawerActionsProps> = ({
  className,
  style,
  children,
}) => {
  const classes = useStyles();
  return (
    <Box className={clsx(classes.root, className)} style={style}>
      {children}
    </Box>
  );
};
